import moment from 'moment-timezone'

export default {
  methods: {
    _setDate(date, timezone, isStart) {
      const zoneDiff =
        moment()
          .tz(timezone)
          .utcOffset() * -1
      if (isStart === true) {
        date =
          moment(date)
            .startOf('day')
            .add(zoneDiff, 'minutes')
            .format('YYYY-MM-DD[T]HH:mm:ss') + 'Z'
      } else {
        date =
          moment(date)
            .endOf('day')
            .add(zoneDiff, 'minutes')
            .format('YYYY-MM-DD[T]HH:mm:ss') + 'Z'
      }
      return date
    },
    _getDate(date, timezone) {
      const zoneDiff = moment()
        .tz(timezone)
        .utcOffset()
      date =
        moment(date)
          .add(zoneDiff, 'minutes')
          .format('YYYY-MM-DD[T]HH:mm:ss') + 'Z'
      return date
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dateUTC.js